import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from '../lib/axios';
import Modal from './Modal';

export default class ConfirmedAsyncFunctionTrigger extends Component {
  static propTypes = {
    url: PropTypes.string.isRequired,
    method: PropTypes.string.isRequired,
    data: PropTypes.object,
    triggerLabel: PropTypes.string,
    triggerClassName: PropTypes.string,
    triggerExtraClassName: PropTypes.string,
    triggerIcon: PropTypes.string,
    triggerIconExtraClassName: PropTypes.string,
    modalHeader: PropTypes.string,
    modalBody: PropTypes.string,
    buttonCancelLabel: PropTypes.string,
    buttonCancelClassName: PropTypes.string,
    buttonConfirmLabel: PropTypes.string,
    buttonConfirmClassName: PropTypes.string,
    redirectUrl: PropTypes.string,
  }

  static defaultProps = {
    data: null,
    triggerLabel: 'Submit',
    triggerClassName: '',
    triggerExtraClassName: 'u-inline-flex u-items-center',
    triggerIcon: '',
    triggerIconExtraClassName: 'u-mr-2',
    modalHeader: '',
    modalBody: '',
    buttonCancelLabel: 'Cancel, go back',
    buttonCancelClassName: '',
    buttonConfirmLabel: '',
    buttonConfirmClassName: '',
    redirectUrl: null,
  }

  constructor(props) {
    super(props);

    this.state = {
      modalVisible: false,
      modalButtonsDisabled: false,
    };
  }

  handleSubmitClick = (e) => {
    this.setState({ modalButtonsDisabled: true });
    const {
      method, url, data, redirectUrl,
    } = this.props;
    axios({
      method,
      url,
      data,
    }).then(() => {
      if (method === 'delete' && redirectUrl !== null) {
        window.location.href = redirectUrl;
      } else {
        window.location.reload();
      }
    });
  }

  handleTriggerClick = (e) => {
    this.setState({ modalVisible: true });
  }

  handleCancelClick = (e) => {
    this.setState({ modalVisible: false });
  }

  render() {
    return (
      <>
        <Modal visible={this.state.modalVisible} onClose={this.handleCancelClick} modalWrapperClassName="u-max-w-md">
          <div className="u-p-6 u-relative">
            <span className="Modal-close Modal-dismiss" onClick={this.handleCancelClick}>
              <i className="Icon Icon-close" />
            </span>
            <div className="u-text-center u-text-red">
              <i className="Icon Icon-warning u-text-double" />
              <h4 className="u-text-2xl u-font-semibold u-text-red u-leading-none u-my-4">{this.props.modalHeader}</h4>
            </div>
            <div className="u--mx-6 u-px-8 u-py-4 u-text-grey-darker-darkest u-text-lg u-bg-red-super-light">{this.props.modalBody}</div>
            <div className="u-mt-6 u-flex u-w-full u-justify-center">
              <button
                type="button"
                className={`Button Button--large Modal-dismiss u-mr-4 ${this.props.buttonCancelClassName} ${this.state.modalButtonsDisabled ? 'is-disabled' : ''}`}
                onClick={this.handleCancelClick}>
                {this.props.buttonCancelLabel}
              </button>
              <button
                type="submit"
                className={`Button Button--large ${this.props.buttonConfirmClassName} ${this.state.modalButtonsDisabled ? 'is-disabled' : ''}`}
                onClick={this.handleSubmitClick}>
                {this.props.buttonConfirmLabel}
              </button>
            </div>
          </div>
        </Modal>
        <span className={`u-cursor ${this.props.triggerClassName} ${this.props.triggerExtraClassName}`} onClick={this.handleTriggerClick}>
          {this.props.triggerIcon && <i className={`${this.props.triggerIcon} ${this.props.triggerIconExtraClassName}`} />}
          <span>
            {this.props.triggerLabel}
          </span>
        </span>
      </>
    );
  }
}
